import { render } from "./ContactCoach.vue?vue&type=template&id=7dff6804&scoped=true"
import script from "./ContactCoach.vue?vue&type=script&lang=js"
export * from "./ContactCoach.vue?vue&type=script&lang=js"

import "./ContactCoach.vue?vue&type=style&index=0&id=7dff6804&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dff6804"

export default script